import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Wrapper = styled(Link)`
  flex-shrink: 0;
  margin: 20px;
  line-height: 0;

  @media (min-width: 768px) {
    margin: 16px 30px;
  }
`

const Img = styled.img`
  height: 32px;

  @media (min-width: 768px) {
    height: 40px;
  }
`

const Logo = ({ className }) => (
  <Wrapper to="/" className={className}>
    <Img src="/spir_logo.svg" alt="" />
  </Wrapper>
)

export default Logo



// WEBPACK FOOTER //
// ./src/components/Header/Logo.js